<template>
  <div v-if="false" class="w-100 d-flex justify-content-center">
    <div style="max-width: 600px" class="w-100">
      <TopMenus class="w-100 p-3" />
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-center">
    <IndexMenuItem :menu-items="memberMenuItems" style="max-width: 900px" />
  </div>
  <div class="d-flex align-items-center justify-content-center">
    <IndexMenuItem :menu-items="userMenuItems" style="max-width: 900px" />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import { useRouterUtil, useUser, useAuthorize } from "/@/vue/composables";
import { TopMenus } from "/@/vue/components/Molecules/IndexPage";
import { MenuItems as IndexMenuItem } from "/@/vue/components/Organisms/Index";

const { currentRouteQuery, dropQuery, reload } = useRouterUtil();

const toast = useToast();

function showSuccessToast() {
  toast.add({
    severity: "success",
    summary: "認証成功",
    detail: "メールアドレスの認証に成功しました。",
    group: "br",
  });
}

onMounted(() => {
  if (currentRouteQuery.value.confirmation) {
    showSuccessToast();
  }

  dropQuery();
});

// user

const { user } = useUser();

const nomalMenuItems = [
  {
    label: "協会概要",
    icon: "pi pi-sitemap",
    to: { name: "About" },
    tabKey: "top",
    visible: true,
  },
  {
    label: "広報誌『わ』",
    icon: "pi pi-book",
    to: { name: "MagazinesIndex" },
    tabKey: "top",
    visible: true,
  },
  {
    label: "賛助会員",
    icon: "pi pi-users",
    to: { name: "Sponsor" },
    tabKey: "top",
    visible: true,
  },
  {
    label: "お問い合わせ",
    icon: "pi pi-info-circle",
    to: { name: "Inquiry" },
    tabKey: "top",
    visible: true,
  },
  //...createMenuItems(13, "top"),
  //...createMenuItems(18, "search"),
  //...createMenuItems(8, "application"),
  //...createMenuItems(4, "inquiry"),
];

const memberMenuItems = [
  {
    label: "お知らせ",
    icon: "pi pi-bell",
    to: { name: "UsersNewsUserNewsIndex" },
    tabKey: "top",
    visible: true,
  },
  {
    label: "研修一覧",
    icon: "pi pi-video",
    to: { name: "UsersTrainingsIndex" },
    tabKey: "top",
    visible: true,
  },
  {
    label: "BCP",
    icon: "pi pi-file-check",
    to: { name: "UsersBcpIndex" },
    tabKey: "top",
    visible: true,
  },
  {
    label: "協会書類等",
    icon: "pi pi-inbox",
    to: { name: "UsersRulesIndex" },
    tabKey: "top",
    visible: true,
  },

  //...createMenuItems(13, "top"),
  //...createMenuItems(18, "search"),
  //...createMenuItems(8, "application"),
  //...createMenuItems(4, "inquiry"),
];

const { logout } = useAuthorize();

const userMenuItems = computed(() => {
  if (user.value) {
    return [
      {
        label: "マイページ",
        icon: "pi pi-user",
        to: { name: "UsersIndex", params: { id: user.value.id } },
        tabKey: "top",
        visible: true,
      },
      /*
      {
        label: "申請済ボランティア",
        icon: "pi pi-briefcase",
        visible: true,
        to: {
          name: "UsersJoinUsersIndex",
        },
        tabKey: "top",
      },
      {
        label: "ボランティア申請",
        icon: "pi pi-briefcase",
        visible: true,
        to: {
          name: "UsersRecruitmentsIndex",
        },
      },
      */
      {
        label: "ログアウト",
        icon: "pi pi-sign-out",
        tabKey: "top",
        command: async () => {
          await logout();
          reload();
        },
        visible: true,
      },
    ];
  } else {
    return [
      {
        label: "会員の方",
        icon: "pi pi-sign-in",
        to: { name: "SignIn" },
        tabKey: "top",
        visible: true,
      },
    ];
  }
});
</script>

<style scoped lang="scss"></style>
